import React from 'react';
import {createRoot} from 'react-dom/client';
import {useRef, useEffect, useState} from 'react';
import axios from 'axios';
import DeviceCard from './deviceCard/deviceCard';
import { Outlet } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignal } from '@fortawesome/free-solid-svg-icons';
// import './dashboard.css';

function dashboard() {
    const [comp, setComp] = useState(null);
    const [iot, setIot] = useState(null);

    const ref = useRef(null);

    useEffect(() => {

        const getCookie = (name) => {
            const match = document.cookie
              .split("; ")
              .find((row) => row.startsWith(name + "="));
          
            if (!match) return null; // Return null if cookie not found
      
            try {
              const rawValue = match.split("=")[1];
            //   console.log(`Raw cookie value for ${name}:`, rawValue);
              return decodeURIComponent(rawValue); // Properly decode it
            } catch (error) {
              console.error(`Error decoding cookie ${name}:`, error);
              return null; // Return null if decoding fails
            }
          };

        const deviceData = async() => {
            try {
                const loginToken = getCookie('data');
                // console.log(loginToken);
                const ddata = await axios({
                    url: `${import.meta.env.VITE_DEVBACKENDPATH}:${import.meta.env.VITE_BACKENDPORT}/api/devicedata/fetchall`, 
                    method: 'POST',
                    headers: {
                        // ADDED Security Measure
                        //apiKey: 'qazwsxedcrfvvfrcdexswzaq',
                        // 'Access-Control-Allow-Origin': '*'
                    },
                    data: {
                        loginToken: loginToken
                    }
                });

                // setData(ddata.data.deviceData);
                const deviceData = ddata.data.deviceData;

                const compCards = [];
                const iotCards = [];
                let count = 0;
                
                // Map devices to either Computer or IoT Device
                deviceData.map(device => {
                    const comp = React.createElement(DeviceCard, {key: `device-${count}`, devicedatar: device});
                    if(device.deviceType === "computer") {
                        compCards.push(comp);
                    } else if(device.deviceType === "IoT") {
                        iotCards.push(comp);
                    }
                    count++;
                });

                setComp(compCards);
                setIot(iotCards);
                
            } catch (err) {
                console.log(err);
            }
        }
        deviceData();

        const element = ref.current;

    },[]);

    return(       
        <article className='margin-t-xxl'>
            <section className='flex column align-start-switch'>
                <div id='mycomputers' className='card-lg flex column border margin-b-md'>
                    <div className='flex row space-between border-bottom width-100p'>
                        <h3 className="h1 margin-l-md margin-r-md">Your Computers</h3>
                        <a href='/dashboard/add/computer' className='font-xl text-decoration-none color-foreground margin-l-md margin-r-md' data-toggle="tooltip" data-placement="bottom" title="Add Computer"><h1 className=''>+</h1></a>
                    </div>
                    <div id='devices-computers' className='flex row-switch flex-nowrap align-items-start justify-content-start width-100p'>
                        {comp}
                        {/* <DeviceCard devicedatar={} /> */}
                    </div>
                </div>
                <div id='myiotdevices' className='card-lg flex column border margin-b-md'>
                    <div className='flex row space-between border-bottom width-100p'>
                        <h3 className="h1 margin-l-md margin-r-md">Sensors</h3>
                        <a href='/dashboard/add/iotdevice' className='font-xl text-decoration-none color-foreground margin-l-md margin-r-md' data-toggle="tooltip" data-placement="top" title="Add IoT Device"><h1 className=''>+</h1></a>
                    </div>
                    <div id='devices-iot' className='flex row-switch flex-nowrap align-items-start justify-content-start width-100p'>
                        {iot}
                    </div>
                </div>
            </section>
        </article>
    );
}

export default dashboard;